import styled from "styled-components";

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
	justify-content: center;
	align-items: center;
		
	& > span {
			text-align: center;
	}	
`